import React, { useState } from "react";
import "./Deletemodal.css";
import { ReactComponent as CheckCircleIcon } from "./assets/checkcircleicon.svg";
import { ReactComponent as DeleteModalIcon } from "./assets/deletemodalicon.svg";
import Button from "@mui/material/Button";
import { Dialog, DialogContent } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import { ReactComponent as CloseIcon } from "./assets/closeicon.svg";
import axiosInstance from "./utils/axios";

export default function DeleteUserModal(props: any) {
    const [loading, setLoading] = useState(false);
    const [isSuccess, setisSuccess] = useState(false);
    const rowItem = props.getRowItem;
    const handleClose = () => {
        props.handleCloseDialog(false);
        setisSuccess(false);
    };

    const onDelete = async () => {
        setLoading(true);
        let postUrl = `/userlist/delete/${rowItem.id}`;
        let postMethod = "DELETE";
        axiosInstance(postUrl, {
            method: postMethod,
            data: rowItem,
            headers: {
                // 'Authorization': `bearer ${token}`,
                "Content-Type": "application/json",
            },
        })
            .then((response: any) => {
                if (response) {
                    setisSuccess(true);
                    console.log(response.data);
                }
                setLoading(false);
            })
            .catch((error) => {
                console.log(error.response.data.error);
                setLoading(false);
            });
    };

    return (
        <Dialog
            open={props.isDeleteModalOpen}
            onClose={handleClose}
            fullWidth
            maxWidth="sm"
        >
            {/* {(!isSuccess) ?
        <DialogTitle id="abtestparticipant-modal-title">
          <IconButton aria-label="close" onClick={handleClose} sx={{ position: 'absolute', right: 8, top: 8, color: "#393939" }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle> :
        <DialogTitle id="abtestparticipant-modalsuccess-title">
          <IconButton aria-label="close" onClick={() => { handleClose(); props.getCandidateList();}}  
            sx={{ position: 'absolute', right: 8, top: 8, color: "#393939" }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
      } */}
            {!isSuccess ? (
                <div>
                    <DialogContent>
                        <CloseIcon
                            style={{
                                position: "absolute",
                                right: 18,
                                top: 10,
                                color: "#393939",
                                cursor: "pointer",
                            }}
                            onClick={() => {
                                handleClose();
                            }}
                        />
                        <div className="delete-section">
                            <div className="deleteicon-section">
                                <DeleteModalIcon
                                    style={{ width: "40px", height: "40px" }}
                                />
                            </div>
                            <div className="deletetitle-section">
                                Are you sure ?
                            </div>

                            <div className="deletecontent-section">
                                Are you sure you want to delete the User{" "}
                                <strong>“{rowItem.name}” </strong> ?
                            </div>
                        </div>
                    </DialogContent>
                    <Stack
                        direction="row"
                        spacing={2}
                        justifyContent="center"
                        sx={{ paddingBottom: "2.5em" }}
                    >
                        <Button
                            variant="outlined"
                            sx={{
                                textTransform: "capitalize",
                                color: "#227AD2",
                                borderColor: "#227AD2",
                                padding: "5px 28px",
                            }}
                            onClick={handleClose}
                        >
                            Cancel
                        </Button>
                        <div className="delete-btn">
                            <Button
                                variant="contained"
                                sx={{
                                    textTransform: "capitalize",
                                    color: "#fff",
                                    background: "#d32f2f",
                                    padding: "5px 36px",
                                }}
                                onClick={onDelete}
                            >
                                Delete
                            </Button>
                        </div>
                    </Stack>
                </div>
            ) : (
                <div>
                    <DialogContent>
                        <div className="modalsuccess-section">
                            <div className="successicon-section">
                                <CheckCircleIcon
                                    style={{
                                        fontSize: "3em",
                                        color: "#166122",
                                    }}
                                />
                            </div>
                            <div className="deletesuccess-section">
                                The Candidate <strong>“{rowItem.name}”</strong>{" "}
                                was deleted successfully.
                            </div>
                            <div className="successclose-section">
                                <Button
                                    variant="outlined"
                                    sx={{
                                        textTransform: "capitalize",
                                        color: "#227AD2",
                                        borderColor: "#227AD2",
                                        padding: "5px 28px",
                                    }}
                                    onClick={() => {
                                        handleClose();
                                        props.getUserList();
                                    }}
                                >
                                    Close
                                </Button>
                            </div>
                        </div>
                    </DialogContent>
                </div>
            )}
            {loading ? (
                <div className="load-spinner">
                    <CircularProgress size="4rem" sx={{ color: "#fff" }} />
                    <div className="spinner-text">Loading....</div>
                </div>
            ) : (
                ""
            )}
        </Dialog>
    );
}
